export enum CallAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_CALL_LIST = "UPDATE_CALL_LIST",
    UPDATE_CALL = "UPDATE_CALL",
    UPDATE_CALL_SEARCH_REQ = "UPDATE_CALL_SEARCH_REQ",
    ADD_CALL_LIST = "ADD_CALL_LIST",
    UPDATE_EMPLOYEE_LIST = "UPDATE_EMPLOYEE_LIST",
}